// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"eebbada8","667":"eebbada8","724":"eebbada8"}[chunkId] + ".chunk.css";
};